/**
 * UserFieldType — F12.C T12.C.2.
 * Przypisanie do użytkownika tenanta (np. „opiekun"). Storage: PG UUID.
 * Używa UserPicker z wyszukiwarką po displayName i email.
 */

import { UserPicker } from '@/components/ui/UserPicker';

import type { FieldInputProps, FieldTypeDefinition } from '../FieldRegistry';

function UserInput({ field, value, onChange, disabled }: FieldInputProps) {
  return (
    <div data-testid={`field-${field.slug}-input`}>
      <UserPicker
        value={typeof value === 'string' ? value : null}
        onChange={onChange as (v: string | null) => void}
        placeholder={`Wybierz ${field.name.toLowerCase()}…`}
        disabled={disabled}
        data-testid={`field-${field.slug}-picker`}
      />
    </div>
  );
}

export const UserFieldType: FieldTypeDefinition = {
  type: 'user',
  renderInput: (props) => <UserInput {...props} />,
  renderCell: (_field, value) => (typeof value === 'string' ? value.slice(0, 8) + '…' : '—'),
  defaultValue: null,
};
